import {createEntityAdapter, createSlice} from "@reduxjs/toolkit";
import {rxInit} from "./appSlice";

const transactionsAdapter = createEntityAdapter({
  sortComparer: (a, b) => (b.valueDate + b.id).localeCompare(a.valueDate + a.id)
});

const initialState = {
  transactions: transactionsAdapter.getInitialState(),

  editor: {
    show: false,
    mode: null,
    deleteConfirmationModal: false
  }
};

export const portfolioSlice = createSlice({
  name: "portfolio",
  initialState,
  reducers: {
    showEditor: (state, action) => {
      state.editor.show = true;
      state.editor.mode = action.payload.mode;
      state.editor.transaction = action.payload.transaction;
      state.editor.deleteConfirmationModal = false;
    },

    hideEditor: state => {
      state.editor.show = false;
      state.editor.deleteConfirmationModal = false;
    },

    showHideDeleteConfirmationModal: (state, action) => {
      state.editor.deleteConfirmationModal = action.payload;
    },

    updatePortfolioTransactions: (state, action) => {
      transactionsAdapter.setMany(state.transactions, action.payload.uportfolioTransactions || []);
      transactionsAdapter.removeMany(state.transactions, action.payload.dportfolioTransactions || []);
    }
  },
  extraReducers: builder => {
    builder.addCase(rxInit, (state, action) => {
      transactionsAdapter.setMany(state.transactions, action.payload.portfolioTransactions);
    });
  }
});

export const {
  showEditor: rxShowPortfolioTransactionEditor,
  hideEditor: rxHidePortfolioTransactionEditor,
  updatePortfolioTransactions: rxUpdatePortfolioTransactions,
  showHideDeleteConfirmationModal: rxShowHideDeleteConfirmationModal
} = portfolioSlice.actions;

export const {selectAll: selectAllPortfolioTransactions} = transactionsAdapter.getSelectors(state => state.portfolio.transactions);

export const editorConfigSelector = state => state.portfolio.editor;

export default portfolioSlice.reducer;
